.error-image{height:70vh;background-image:url("./media/404-KVFB34ID.svg");background-repeat:no-repeat;background-position:center;background-size:60vh}
/*# sourceMappingURL=not-found.component-J3NLG2R3.css.map */
